import { useEffect } from 'react';

/**
 * Sets the document title for a route.
 *
 * Not cosmetic: in a single-page app the title is the only thing that changes
 * for a screen reader on navigation, so without this every page announces the
 * same name (WCAG 2.4.2).
 */
export function usePageTitle(title: string): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
